const viteProd = import.meta.env.PROD;
const appEnv = import.meta.env.VITE_APP_ENV || 'development';
export const isProd = (viteProd === true && !appEnv.startsWith('dev'));

export const logVerbose = (!isProd && import.meta.env.VITE_LOG_VERBOSE === 'true');
if (logVerbose) console.debug(`Environment: ${appEnv} (Vite env.PROD: ${viteProd})`);

const mockAuth = import.meta.env.VITE_MOCK_AUTH || '';
export const devUserId = (!isProd && (mockAuth && mockAuth.startsWith('test'))) ? mockAuth : '';
if (devUserId) console.warn(`Mocking Dev User: ${devUserId}`);
// Below mocks do not get populated for build/nginx
export const isMockData = import.meta.env.VITE_MOCK_DATA === 'true';
if (isMockData) console.warn(`Allowing mock API response data`);

export const gcpProjectId = import.meta.env.VITE_GCP_PROJECT_ID?.trim();
if (gcpProjectId && logVerbose) console.debug(`GCP Project ID: ${gcpProjectId}`);
export const isLocal = !gcpProjectId || gcpProjectId.includes('local');

export const firebaseApiKey = import.meta.env.VITE_FIREBASE_API_KEY;
export const firebaseAuthDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
export const isFirebase = (!!firebaseApiKey && !!firebaseAuthDomain);

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const GITHUB_CLIENT_ID = import.meta.env.VITE_GITHUB_CLIENT_ID;

export const defaultPage = 'Dashboard';

export const mapCenter = [20, 0];
export const mapClip = true;
export const mapClipBounds = [
  [-85.0511, -180], // Bottom-Left: Near Antarctica / Alaska edge
  [85.0511, 180]    // Top-Right: Near Arctic / Russian edge (wrapping past 180)
];

const backendUrl = import.meta.env.VITE_API_URL || '';
// If we are on the sslip.io/production domain, use relative paths to kill CORS.
// If we are on localhost, use the full URL to hit our local dev server.
export const API_BASE_URL = (
  window.location.hostname.includes('sslip.io') ||
  window.location.hostname.includes('run.app') ||
  (!isProd && backendUrl.includes('docker.internal'))
) ? '' : backendUrl;
if (logVerbose) {
  console.debug(`Hostname: ${window.location.hostname}`);
  console.debug(`Backend URL: ${backendUrl}`);
  if (backendUrl !== API_BASE_URL) console.debug(`Adjusted URL: ${API_BASE_URL}`);
}

export const API_PREFIX = '/api/v1';
export const ApiEndpoint = Object.freeze({
  TOKEN: `${API_BASE_URL}${API_PREFIX}/auth/token`,
  AUTHME: `${API_BASE_URL}${API_PREFIX}/auth/me`,
  SCHEMA: `${API_BASE_URL}${API_PREFIX}/schema`,
  SIMS: `${API_BASE_URL}${API_PREFIX}/sims`,
  APNS: `${API_BASE_URL}${API_PREFIX}/apns`,
  MESSAGES: `${API_BASE_URL}${API_PREFIX}/messages`,
  DEVICES: `${API_BASE_URL}${API_PREFIX}/devices`,
  DEMO: `${API_BASE_URL}${API_PREFIX}/decoded`,
  CUSTOMERS: `${API_BASE_URL}${API_PREFIX}/customers`,
  COVERAGE: `${API_BASE_URL}${API_PREFIX}/coverage`,
  CODECS: `${API_BASE_URL}${API_PREFIX}/codecs`,
  USERS: `${API_BASE_URL}${API_PREFIX}/users`,
  DEV: `${API_BASE_URL}${API_PREFIX}/dev`,
});

export const niddApiSwaggerUrl = (
  import.meta.env.VITE_NIDD_SWAGGER_URL ||
  'https://inmarsat-enterprise.github.io/ntn-poc-nidd-api'
);

export const udpProxyHost = import.meta.env.VITE_UDP_PROXY_HOST || 'dev.34.31.212.200.sslip.io'
export const udpProxyPort = import.meta.env.VITE_UDP_PROXY_PORT || '5683'
